import ConsultaGestores from "./ConsultaGestores";

export default ConsultaGestores;
